import { formatNumber } from '@shared/utils/formatNumber';
import { chartColorVar } from '@shared/modules/chart-colors';

// Inline-CSS colours for the report's HTML/SVG marks (canvas charts use chartColor() directly)
export const INSIGHTS_COLORS = {
    sent: chartColorVar('eventSent'),
    received: chartColorVar('eventReceived'),
    opened: chartColorVar('eventOpened'),
    clicked: chartColorVar('eventClicked'),
    unsubscribed: chartColorVar('eventUnsubscribed'),
    bounced: chartColorVar('eventBounced'),
    inactive: chartColorVar('eventInactive'),
    campaigns: chartColorVar('primary'),
} as const;

export interface InsightsBarListItem {
    key: string;
    label: string;
    sublabel?: string;
    // ISO country code, renders a flag before the label
    flag?: string;
    value: number;
    displayValue: string;
    href?: string;
}

export const INSIGHTS_PRIMARY = chartColorVar('primary');
export const INSIGHTS_NEUTRAL = chartColorVar('fallback');

export function formatCompact(value: number): string {
    return new Intl.NumberFormat(navigator.language, { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}

export function formatPercent(value: number, decimals = 1): string {
    return `${formatNumber(value, decimals)}%`;
}

export function formatMonth(month: string, style: 'short' | 'long' = 'short'): string {
    return new Date(`${month}-01T12:00:00`).toLocaleDateString(navigator.language, { month: style });
}

// month: yyyy-MM, e.g. "oktober 2026"
export function formatMonthYear(month: string): string {
    return new Date(`${month}-01T12:00:00`).toLocaleDateString(navigator.language, { month: 'long', year: 'numeric' });
}

// Reads a font-size custom property from Content/ungapped/variables/root.less (e.g. '--font-size-small') as pixels
export function rootFontSize(variable: string): number {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue(variable)) || 14;
}
